export const ServiceBus = {
  $services: new Map(),

  $inject(serviceName, service) {
    if (!this.$services.get(serviceName)) {
      this.$services.set(serviceName, { name: serviceName, service });
    }
    return this.$services.get(serviceName);
  },

  $getService(serviceName) {
    if (!this.$services) {
      return null;
    }
    if (this.$services.get(serviceName)) {
      return this.$services.get(serviceName);
    }
    return null;
  }
};
